// extracted by mini-css-extract-plugin
export default {"container":"PostListPage_container__xwGja","top":"PostListPage_top__M2vk+","notificationBar":"PostListPage_notificationBar__+iPVe","writeButton":"PostListPage_writeButton__ChXjv"};